<div class="error">
  <mat-icon>warning</mat-icon>
  {{ message }}
</div>
